<script lang="ts">
	import type { Coordinates, RouteWithGeometry } from '$lib/components/map/types';
	import type { WayPoint } from '$lib/components/search/itinerary/types';
	import { page } from '$app/state';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import ItineraryMarker from '$lib/components/map/markers/ItineraryMarker.svelte';
	import PreviewPolylines from '$lib/components/map/routePolylines/PreviewPolylines.svelte';
	import { getWaypointCoordinates } from '$lib/components/search/itinerary/ItineraryStore';
	import { isRoutePage, isRoutePageContext } from '$lib/services/urls/routeIds';

	const { itineraryStore } = getMapLayoutContext();

	const { itinerary } = itineraryStore;

	interface Props {
		routes?: RouteWithGeometry[];
	}

	const { routes }: Props = $props();

	let departureCoordinates: Coordinates | undefined = $state();
	let arrivalCoordinates: Coordinates | undefined = $state();

	async function getCoordinates(itinerary: WayPoint[]) {
		departureCoordinates = await getWaypointCoordinates(itinerary[0]);
		arrivalCoordinates = await getWaypointCoordinates(itinerary[itinerary.length - 1]);
	}

	$effect(() => {
		getCoordinates($itinerary);
	});

	const isPreviewPage = $derived(isRoutePage(page.route) && (!routes || routes.length === 0));
</script>

{#if isPreviewPage}
	<PreviewPolylines />
{/if}

{#if isPreviewPage || (isRoutePageContext(page.route) && routes && routes.length > 0)}
	{#if departureCoordinates}
		<ItineraryMarker coordinates={departureCoordinates} icon="location-on-filled" />
	{/if}

	{#if arrivalCoordinates}
		<ItineraryMarker coordinates={arrivalCoordinates} icon="itinerary-arrival" />
	{/if}
{/if}
